import * as React from 'react';
import { cn } from '../lib/cn.ts';

/**
 * Skeleton with a slow shimmer. Hardware-accelerated (transform-only).
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn(
        'relative isolate overflow-hidden rounded-md bg-bg-raised/60',
        'before:absolute before:inset-0 before:-translate-x-full',
        'before:bg-gradient-to-r before:from-transparent before:via-white/[0.04] before:to-transparent',
        'before:animate-shimmer',
        className,
      )}
      {...props}
    />
  );
}
